import React, { useRef, useState, useEffect, forwardRef } from 'react';
import { Modal } from 'react-bootstrap';
import { API_URL_All } from '../../api';
import { toast } from "react-toastify";
import * as general from '../../libs/general';
import axiosInstance from '../../axiosInstance';

const TransferRequester = ({ data, handleSearch }) => {
  const [show, setShow] = useState(true);
  const [model, setModel] = useState({});

  useEffect(() => {
    initializeData(data);
  }, [data]);


  const handleModalClose = (e) => {
    document.querySelectorAll('.show .error-msg').forEach((item) => {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });
    document.activeElement.blur();
    setShow(false);
  };

  const handleSubmitForm = async(e) => {
    e.preventDefault();
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    var dataModel = { ...model };


    general.openConfirm(async () => {
      try {
        var requestApi = `/api/import-orders/requestTransferOrders`;
        const response = await axiosInstance.post(requestApi, dataModel);
        if (!response.data.success) {
          general.showFormError('.show .modal-body', response.data);
          console.log(response.data);
          return;
        }
        console.log(response);
        toast.success(response.data.message);
        if (handleSearch) handleSearch();
        handleModalClose();
      } catch (error) {
        toast.error(error.message);
      }

    }, "Bạn có chắc chắn muốn gửi yêu cầu này đến ZTO không?");



  };

  const initializeData = async (obj) => {
    var orderId = obj.id;
    const isNumber = Number.isFinite(orderId);
    if (!isNumber) {
      orderId = 0;
    }

    const idsText = obj.listIds.join(';');

    setModel({});
    try {
      var urlApi = `/api/import-orders/searchorders?customers=ZTO-VH00&orderIds=${idsText}`;
      var response = await axiosInstance.get(urlApi);
      var obj = response.data;

      setModel(obj);
      setShow(true);
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  };

  return (
    <Modal show={show} onHide={handleModalClose} size="lg">
      <div className="">
        <form id="order_editor_form" className="form_validate normal-form" autoComplete="off" onSubmit={handleSubmitForm}>
          <div className="modal-content">
            <div className="modal-header position-relative flex-between">
              {model.orderCode && (<span className="record_id">Code: {model.orderCode}</span>)}
              <div>
                <h5 className="modal-title">Xác nhận đơn hàng của tôi</h5>
                {model.error && (
                  <div className="error-msg-server">{model.error}</div>
                )}
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={handleModalClose}
                aria-label="Đóng"
              ></button>
            </div>
            <div className="modal-body mt-2">

              <div className="row">
                <div className="col-md-12 mb-3">

                  <div className="group-box p-0" data-text="Danh sách đơn hàng">


                    <section className="p-1 pt-4">
                      <div className="table-responsive border table-normal table-sticky">
                        <table className="table table-striped border-normal table-bordered">
                          <thead className="table-primary head-01">
                            <tr>
                              <th className='sticky text-center' width="21px"></th>

                              <th className="text-center"><span>Ngày</span></th>
                              <th className="text-center">Mã vận đơn TQ</th>
                              <th className="d-none text-center"><span>Mã Khách hàng</span></th>
                              <th>Tên đơn hàng</th>
                              <th>Xác nhận</th>
                            </tr>
                          </thead>
                          {model.page && model.page.content && model.page.content.map((item, index) => (
                            <tbody className="tbody-row">
                              <tr key={index}>
                                <td className='sticky text-center' title={`orderCode: ${item.orderCode}`}>
                                  {index + 1}
                                </td>
                                <td className="text-success text-center" title={item.lineName}>{general.formatDate2(item.createdDate)}</td>
                                <td className="text-success text-center">{item.cnShippingCode}</td>
                                <td className='text-success text-center d-none'>{item.customerCode}</td>
                                <td className="text-success text-start">{item.name}</td>
                                <td className="text-success text-start">{item.confirmedText}</td>
                              </tr>
                            </tbody>
                          ))}

                        </table>
                      </div>
                    </section>
                  </div>
                  <div>
                    <b>Tôi cam đoan những đơn hàng này là của tôi. Yêu cầu ZTO chuyển những đơn hàng này vào danh sách đơn hàng của tôi.<br /> Tôi xin chân thành cảm ơn.</b>
                  </div>
                </div>



              </div>


            </div>
            <div className="modal-footer justify-content-between">
              <div>
              </div>
              <button type="submit" className="btn-sm btn btn-primary">Gửi yêu cầu</button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default TransferRequester;
